import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IReportsAdminRefferal_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IReportsAdminRefferal_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  KuikaB2B_OrderSalesCustomerMobile: any[];
  KuikaB2B_OrderSalesCustomerMobile_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  isComp498726Visible: "visible" | "hidden";
}

export class ReportsAdminRefferal_ScreenBase extends React.PureComponent<
  IReportsAdminRefferal_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  reportsadminrefferal_702637_value_kuikaSelectBoxRef: React.RefObject<any>;
  reportsadminrefferal_220915_value_kuikaDateRef: React.RefObject<any>;
  reportsadminrefferal_785547_value_kuikaDateRef: React.RefObject<any>;
  reportsadminrefferal_893769_value_kuikaTableRef: React.RefObject<any>;
  reportsadminrefferal_213413_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 370241,
          PropertyName: "value",
          Value: "Sevk Raporu",
          TagName: "Label16_value",
        },
        {
          Id: 126187,
          PropertyName: "value",
          Value: "Siparişler",
          TagName: "Label2_value",
        },
        {
          Id: 307986,
          PropertyName: "label",
          Value: "Export",
          TagName: "Button3_label",
        },
        {
          Id: 351625,
          PropertyName: "value",
          Value: "Filtre",
          TagName: "Label1_value",
        },
        {
          Id: 980890,
          PropertyName: "value",
          Value: "Tarih Filtresi",
          TagName: "Label6_value",
        },
        {
          Id: 702637,
          PropertyName: "placeholder",
          Value: "Tarih Aralığı",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 220915,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 785547,
          PropertyName: "placeholder",
          Value: "Bitiş Tarihi...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 337972,
          PropertyName: "label",
          Value: "Temizle",
          TagName: "Button2_label",
        },
        {
          Id: 155696,
          PropertyName: "label",
          Value: "Uygula",
          TagName: "Button1_label",
        },
        {
          Id: 170,
          PropertyName: "value",
          Value: "Müşteri Kodu",
          TagName: "Label29_value",
        },
        {
          Id: 345238,
          PropertyName: "value",
          Value: "Müşteri Ünvan",
          TagName: "Label31_value",
        },
        {
          Id: 700803,
          PropertyName: "value",
          Value: "Miktar",
          TagName: "Label33_value",
        },
        {
          Id: 28538,
          PropertyName: "value",
          Value: "Metrekare",
          TagName: "Label35_value",
        },
        {
          Id: 825803,
          PropertyName: "value",
          Value: "Sevk Miktarı",
          TagName: "Label37_value",
        },
        {
          Id: 663496,
          PropertyName: "value",
          Value: "Sevk Metrekare",
          TagName: "Label39_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 370241,
          PropertyName: "value",
          Value: "Dispatch Report",
          TagName: "Label16_value",
        },
        {
          Id: 126187,
          PropertyName: "value",
          Value: "Orders",
          TagName: "Label2_value",
        },
        {
          Id: 307986,
          PropertyName: "label",
          Value: "Export",
          TagName: "Button3_label",
        },
        {
          Id: 351625,
          PropertyName: "value",
          Value: "Filter",
          TagName: "Label1_value",
        },
        {
          Id: 980890,
          PropertyName: "value",
          Value: " Date Filter",
          TagName: "Label6_value",
        },
        {
          Id: 702637,
          PropertyName: "placeholder",
          Value: "Date Range",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 220915,
          PropertyName: "placeholder",
          Value: "Start Date...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 785547,
          PropertyName: "placeholder",
          Value: "End Date...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 337972,
          PropertyName: "label",
          Value: "Clear",
          TagName: "Button2_label",
        },
        {
          Id: 155696,
          PropertyName: "label",
          Value: "Apply",
          TagName: "Button1_label",
        },
        {
          Id: 170,
          PropertyName: "value",
          Value: "Customer Code",
          TagName: "Label29_value",
        },
        {
          Id: 345238,
          PropertyName: "value",
          Value: "Customer Title",
          TagName: "Label31_value",
        },
        {
          Id: 700803,
          PropertyName: "value",
          Value: "Quantity",
          TagName: "Label33_value",
        },
        {
          Id: 28538,
          PropertyName: "value",
          Value: "Square meters",
          TagName: "Label35_value",
        },
        {
          Id: 825803,
          PropertyName: "value",
          Value: "Shipment Quantity",
          TagName: "Label37_value",
        },
        {
          Id: 663496,
          PropertyName: "value",
          Value: "Shipping per square meter",
          TagName: "Label39_value",
        },
        {
          Id: 62858224,
          PropertyName: "e41db796-e771-1974-ca68-d074f5f95dea_notify",
          Value: "Report Successfully Generated",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ae7bdfc2-5b43-41fe-90c7-dda3d8c95995",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 370241, PropertyName: "value", Value: "Sevk Raporu" },
        { Id: 351625, PropertyName: "value", Value: "Filtre" },
        { Id: 980890, PropertyName: "value", Value: "Tarih Filtresi" },
        { Id: 702637, PropertyName: "placeholder", Value: "Tarih Aralığı" },
        {
          Id: 220915,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi...",
        },
        { Id: 785547, PropertyName: "placeholder", Value: "Bitiş Tarihi..." },
        { Id: 337972, PropertyName: "label", Value: "Temizle" },
        { Id: 155696, PropertyName: "label", Value: "Uygula" },
        { Id: 126187, PropertyName: "value", Value: "Siparişler" },
        { Id: 307986, PropertyName: "label", Value: "Export" },
        { Id: 936917, PropertyName: "title", Value: "Title" },
        { Id: 170, PropertyName: "value", Value: "Müşteri Kodu" },
        {
          Id: 560002,
          PropertyName: "value",
          Value: "[datafield:customercode]",
        },
        { Id: 345238, PropertyName: "value", Value: "Müşteri Ünvan" },
        {
          Id: 522106,
          PropertyName: "value",
          Value: "[datafield:customerdescription]",
        },
        { Id: 700803, PropertyName: "value", Value: "Miktar" },
        { Id: 376699, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 28538, PropertyName: "value", Value: "Metrekare" },
        { Id: 552258, PropertyName: "value", Value: "[datafield:qty2]" },
        { Id: 825803, PropertyName: "value", Value: "Sevk Miktarı" },
        {
          Id: 127593,
          PropertyName: "value",
          Value: "[datafield:shipmentqty1]",
        },
        { Id: 663496, PropertyName: "value", Value: "Sevk Metrekare" },
        {
          Id: 644666,
          PropertyName: "value",
          Value: "[datafield:shipmentqty2]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.reportsadminrefferal_702637_value_kuikaSelectBoxRef =
      React.createRef();
    this.reportsadminrefferal_220915_value_kuikaDateRef = React.createRef();
    this.reportsadminrefferal_785547_value_kuikaDateRef = React.createRef();
    this.reportsadminrefferal_893769_value_kuikaTableRef = React.createRef();
    this.reportsadminrefferal_213413_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      KuikaB2B_OrderSalesCustomerMobile: [],
      SetValueOf: "",
      Notify: false,
      dataSource_702637: [
        { key: "10", text: "İki Tarih Arası Filtreleme" },
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      isComp498726Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "reportsadminrefferal",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ReportsAdminRefferalPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ReportsAdminRefferalPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsadminrefferal",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsadminrefferal",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ReportsAdminRefferalPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ReportsAdminRefferalPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ReportsAdminRefferalPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsAdminRefferal/ReportsAdminRefferalPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerMobile =
      result?.data.kuikaB2B_OrderSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ReportsAdminRefferalPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp498726Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_893769 =
      stateVars.KuikaB2B_OrderSalesCustomerMobile ??
      this.state.KuikaB2B_OrderSalesCustomerMobile;
    formVars.reportsadminrefferal_213413_total = ReactSystemFunctions.value(
      this,
      stateVars.KuikaB2B_OrderSalesCustomerMobile !== undefined
        ? stateVars.KuikaB2B_OrderSalesCustomerMobile?.length > 0
          ? stateVars.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
          : null
        : this.state.KuikaB2B_OrderSalesCustomerMobile?.length > 0
        ? this.state.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ReportsAdminRefferalComponent_969295_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalComponent_702637_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ReportsAdminRefferal/ReportsAdminRefferalComponent_702637_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.KuikaB2B_OrderSalesCustomerMobile =
        result?.data.kuikaB2B_OrderSalesCustomerMobile;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalComponent_702637_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalComponent_702637_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalComponent_702637_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsadminrefferal_213413_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    stateVars.isComp498726Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsAdminRefferalComponent_702637_onChange2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ReportsAdminRefferalComponent_702637_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalComponent_702637_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalComponent_702637_onChange3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ReportsAdminRefferalComponent_702637_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.dataSource_893769 =
        stateVars.KuikaB2B_OrderSalesCustomerMobile ??
        this.state.KuikaB2B_OrderSalesCustomerMobile;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalComponent_702637_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalComponent_702637_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ReportsAdminRefferalComponent_702637_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.reportsadminrefferal_213413_total = ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_OrderSalesCustomerMobile !== undefined
          ? stateVars.KuikaB2B_OrderSalesCustomerMobile?.length > 0
            ? stateVars.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
            : null
          : this.state.KuikaB2B_OrderSalesCustomerMobile?.length > 0
          ? this.state.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
          : null
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  ReportsAdminRefferalComponent_337972_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsadminrefferal_220915_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsadminrefferal_785547_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalComponent_155696_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_220915_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_785547_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsAdminRefferal/ReportsAdminRefferalComponent_155696_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerMobile =
      result?.data.kuikaB2B_OrderSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsAdminRefferalComponent_155696_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalComponent_155696_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "reportsadminrefferal_213413_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_893769 =
      stateVars.KuikaB2B_OrderSalesCustomerMobile ??
      this.state.KuikaB2B_OrderSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalComponent_307986_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e41db796_e771_1974_ca68_d074f5f95dea_notify",
        this.defaultML,
        "Rapor Başarıyla Oluşturuldu"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalComponent_213413_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_702637_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_220915_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_785547_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsadminrefferal_213413_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsAdminRefferal/ReportsAdminRefferalComponent_213413_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerMobile =
      result?.data.kuikaB2B_OrderSalesCustomerMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsAdminRefferalComponent_213413_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalComponent_213413_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_893769 =
      stateVars.KuikaB2B_OrderSalesCustomerMobile ??
      this.state.KuikaB2B_OrderSalesCustomerMobile;
    formVars.reportsadminrefferal_213413_total = ReactSystemFunctions.value(
      this,
      stateVars.KuikaB2B_OrderSalesCustomerMobile !== undefined
        ? stateVars.KuikaB2B_OrderSalesCustomerMobile?.length > 0
          ? stateVars.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
          : null
        : this.state.KuikaB2B_OrderSalesCustomerMobile?.length > 0
        ? this.state.KuikaB2B_OrderSalesCustomerMobile[0].totalRows
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ReportsAdminRefferalPageInit();
    }
  }
}
